module.exports = __webpack_public_path__ + "static/media/Badge_SvgSiteConnecte_Gold.4671a898.svg";